<template>
    <v-container fluid>
        <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>
            <v-toolbar flat color="transparent">
                <v-toolbar-title>
                    <h2 v-if="!$route.params.id" :class="$vuetify.theme.isDark ? 'white--text' : ''">
                        Crear Subcategoria
                    </h2>

                    <h2 v-else :class="$vuetify.theme.isDark ? 'white--text' : ''">
                        <v-btn fab small elevation="0" color="secondary" @click="showLog()">
                            <v-icon>mdi-post</v-icon>
                        </v-btn> Editar Subcategoria
                    </h2>
                </v-toolbar-title>

                <v-spacer/>

                <v-btn :disabled="!validForm" class="mx-1" elevation="0" color="primary" rounded @click="validateForm">
                    Guardar
                </v-btn>

                <v-btn class="mx-1" elevation="0" color="error" rounded v-if="$route.params.id" @click="destroyDialog = true">
                    Eliminar
                </v-btn>
            </v-toolbar>

            <v-row>
                <v-col cols="12" md="6">
                    <v-card>
                        <v-card-title class="pb-2">
                            <h4 :class="$vuetify.theme.isDark ? 'white--text' : ''">
                                <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                                Descripción
                            </h4>
                        </v-card-title>

                        <v-card-text>
                            <v-col>
                                <v-select :rules="emptyRule" hide-details dense outline label="Categoria ligada"
                                    v-model="payload.category_id" :items="product_categories" item-value="id" item-text="name"> 
                                </v-select>
                            </v-col>

                            <v-col>
                               <v-text-field :rules="emptyRule" hide-details dense outlined v-model="payload.name" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col>
                               <v-text-field :rules="emptyRule" hide-details dense outlined v-model="payload.slug" label="Slug"></v-text-field>
                            </v-col>
                            <v-col cols="12" class="px-6 py-0">
                                <v-row align="center" justify="center">
                                    <h4 class="mb-0 pr-3" :class="$vuetify.theme.isDark ? 'white--text' : ''">Activo:</h4>
                                    <v-switch :color="$vuetify.theme.isDark ? 'primary' : 'secondary'" v-model="payload.enabled"></v-switch>
                                </v-row>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-dialog v-model="destroyDialog" max-width="400">
                <v-card>
                    <v-card-title class="headline">
                        ¿Estas seguro?
                    </v-card-title>

                    <v-card-text>
                        Una vez elimines el registro, no podrás recuperarlo.
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn rounded color="primary" text @click="destroyDialog = false">
                            Mejor no
                        </v-btn>
                        <v-btn elevation="0" class="pa-4" rounded color="error" @click="destroy">
                            Eliminar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <logDialog ref="logDialog"></logDialog>
        </v-form>
    </v-container>
</template>

<script>
import { mounted } from 'vue2-dropzone';
import logDialog from '../commons/LogViewer'
    export default {
    components:{
        logDialog
    },
        data(){
            //VARIABLES REACTIVAS (QUE SU CAMBIO SE REFLEJA AUTOMATICAMENTE EN LA INTERFAZ)
            return {
                destroyDialog: false,
                validForm:true,
                emptyRule: [v => !!v || 'Necesario'],
                payload: {
                    id: null,
                    name: null,
                    category_id: null,
                    slug: null,
                    enabled: true
                }, 
                product_categories: []
            }
        }, 
        methods: {
            validateForm() {
                if(this.$refs.form.validate()){
                    (this.$route.params.id ? this.update() : this.store())
                }
            }, 

            create() {
                this.$axios
                    .get('/admin/subcategories/create')
                    .then((response) => {
                        console.log("holaaa \n"+response.data)
                        this.product_categories = response.data
                    })
            },

            edit() {
                this.$axios
                    .get(`/admin/subcategories/${this.$route.params.id}/edit`)
                    .then((response) => {
                        this.product_categories = response.data.category
                        this.payload = response.data.item
                    })
            },

            store() {
                let formData = new FormData();

                Object.entries(this.payload).forEach(([key,value])=> {

                    if(key === 'enabled'){
                        formData.append(key,value ? 1 : 0);
                    } else {
                        formData.append(key,value);
                    }
                });

                this.$axios
                    .post('/admin/subcategories', formData)
                    .then((response) => {
                        this.$store.commit('OPEN_SNACKBAR', response.data);
                        (response.data.success ? this.$router.push('/subcategories') : '')
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

            update() {
                let formData =  new FormData();

                Object.entries(this.payload).forEach(([key,value]) => {
                
                    if(key === 'enabled'){
                        formData.append(key,value ? 1 : 0);
                    } else {
                        formData.append(key,value);
                    }

                });

                formData.append('_method','PUT')

                this.$axios
                    .post(`/admin/subcategories/${this.$route.params.id}`, formData)
                    .then((response) => {
                        this.$store.commit('OPEN_SNACKBAR', response.data);
                        (response.data.success ? this.$router.push('/subcategories') : '')
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },

            destroy() {
                let formData = new FormData();

                formData.append('enabled', 0);

                //formData.append('_method', 'DELETE')

                this.$axios
                    .post(`/admin/subcategories/${this.$route.params.id}/desactivar`, formData)
                    .then((response) => {
                        this.$store.commit('OPEN_SNACKBAR', response.data.message);
                        if(response.data.success){
                            this.$router.push('/subcategories');
                        }
                        // (response.data.success ? this.$router.push('/subcategories'): '')
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
        },

        mounted() {
            if(this.$route.params.id){
                this.edit()
            } else {
                this.create()
            }
        }
    }
</script>